import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  InputAdornment,
  Menu,
  MenuItem,
  Switch,
  TextField,
} from "@mui/material";
import { toFullDateName, toNativeDate } from "helpers/dateHelper";
import React, { useEffect, useRef, useState } from "react";
import { useGetChatMessages } from "hooks/useGetChatMessages";
import { toast } from "react-toastify";
import { FaEllipsisH, FaEyeSlash, FaFileAlt, FaSyncAlt, FaTrashAlt } from "react-icons/fa";
import messagesService from "services/admin/messagesService";
import chatsService from "services/admin/chatsService";
import { ChatMessageItem } from "./ChatMessageItem";
import leadsService from "services/admin/leadsService";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { getAuthUser } from "redux/selectors/getUser";

interface ChatMessagesProps {
  chatID: number | null;
  sendMessage: (message: string) => void;
  openUserInfo: any;
  chat: any;
  markAsPersonalChat?: () => void;
  deleteChat: () => void;
}

export const ChatMessages = ({
  chatID,
  sendMessage,
  openUserInfo,
  chat,
  markAsPersonalChat,
  deleteChat,
}: ChatMessagesProps) => {
  const authUser: any = useSelector(getAuthUser);
  const { data: messages, isLoading } = useGetChatMessages(chatID);

  // const [allMessages, setAllMessages] = useState<any[]>([]);
  const [aiEnabled, setAiEnabled] = useState<boolean>(true);
  const [isCreateLeadModalOpen, setIsCreateLeadModalOpen] = useState<boolean>(false);
  // More options
  const [moreOptionsAnchorEl, setMoreOptionsAnchorEl] = useState<null | HTMLElement>(null);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      chatID: chatID,
      source: chat?.source,
      name: "",
      phone: "",
      data: {
        dateFrom: "",
        dateTo: "",
        budget: "",
        product: "",
        personQuantity: 1,
        customers: "",
        departureCity: "",
      },
    },
    mode: "onChange",
  });

  const handleMoreOptionsOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setMoreOptionsAnchorEl(event.currentTarget);
  };

  const handleMoreOptionsClose = () => {
    setMoreOptionsAnchorEl(null);
  };

  useEffect(() => {
    const isAIEnabled =
      chat && chat.channelConnection && chat.channelConnection.status == "ACTIVE" && chat.aiEnabled;
    setAiEnabled(Boolean(isAIEnabled));
  }, [chat]);

  useEffect(() => {
    const messagesBody = document.querySelector(".messages-body");
    if (messagesBody) {
      messagesBody.scrollTo({
        top: messagesBody.scrollHeight,
        behavior: "auto",
      });
    }
  });

  const messageInputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (messageInputRef.current) {
      messageInputRef.current.focus();
    }

    // После нажатие на Enter отправляем сообщение
    document.addEventListener("keydown", (e) => {
      if (e.key === "Enter" && !e.shiftKey) {
        e.preventDefault();
        onSubmit(e);
      }
    });
  }, []);

  const onSubmit = (e: any) => {
    e.preventDefault();
    if (!messageInputRef.current) {
      return;
    }
    if (messageInputRef.current.value.length < 2) {
      toast.error("Сообщение должно быть больше 2 символов");
      return;
    }
    sendMessage(messageInputRef.current.value);
    messageInputRef.current.value = "";
  };

  const deleteMessage = async (messageID: number) => {
    try {
      if (!chatID) {
        toast.error("Чат не найден!");
        return;
      }
      await messagesService.deleteMessage(chatID, messageID);
      toast.success("Сообщение удалено успешно!");
      // setAllMessages((prev) => prev.filter((message) => message.id !== messageID));
    } catch (error) {
      toast.error("Ошибка при удалении сообщения!");
    }
  };

  const handleChangeAiEnabled = async () => {
    try {
      if (!chatID) {
        toast.error("Чат не найден!");
        return;
      }
      await chatsService.put(chatID, { aiEnabled: !aiEnabled });
      toast.success("Статус AI изменен успешно!");
      setAiEnabled(!aiEnabled);
    } catch (error) {
      toast.error("Ошибка при изменении статуса AI!");
    }
  };

  const handleResetAutomation = async () => {
    handleMoreOptionsClose();
    try {
      if (!chatID) {
        toast.error("Чат не найден!");
        return;
      }
      const response: any = await chatsService.resetAutomation(chatID);
      if (response?.data?.reset) {
        toast.success("Автоматизация сброшена");
      } else {
        toast.info("Автоматизация уже сброшена");
      }
    } catch (error) {
      toast.error("Не удалось сбросить автоматизацию");
    }
  };

  // const deleteChat = async () => {
  //   try {
  //     if (!chatID) {
  //       toast.error("Чат не найден!");
  //       return;
  //     }
  //     await chatsService.delete(chatID);
  //     toast.success("Чат удален успешно!");
  //   } catch (error) {
  //     toast.error("Ошика при удалении чата!");
  //     console.error(error);
  //   }
  // };

  const createLead = async (formData: any) => {
    await leadsService.post({ chatID: chatID, ...formData });
    toast.success("Заявку создано успешно!");
    setIsCreateLeadModalOpen(false);
  };
  return (
    <div className="chat-messages">
      <div className="messages-header">
        <div className="messages-header-title flex items-center justify-between w-100">
          <div onClick={openUserInfo} className="cursor-pointer">
            {chat?.contact?.externalUserFirstName ||
              chat?.contact?.externalUserUserName ||
              chat?.contact?.externalUserID ||
              `ID: ${chatID}`}
          </div>
          <div className="flex items-center justify-between gap-2">
            <div>
              {authUser?.email !== "3kempira@gmail.com" && (
                <>
                  <span className="mr-2">AI: {aiEnabled ? "Включено" : "Выключено"}</span>
                  <Switch
                    checked={aiEnabled === true}
                    onChange={handleChangeAiEnabled}
                    disabled={
                      chat && chat.channelConnection && chat.channelConnection.status != "ACTIVE"
                    }
                  />
                </>
              )}
            </div>
            {/* More options button */}
            <IconButton onClick={(event) => handleMoreOptionsOpen(event)}>
              <FaEllipsisH size={14} />
            </IconButton>
            <Menu
              anchorEl={moreOptionsAnchorEl}
              open={Boolean(moreOptionsAnchorEl)}
              onClose={handleMoreOptionsClose}
            >
              <MenuItem onClick={deleteChat} className="flex items-center gap-2">
                <FaTrashAlt size={14} />
                Удалить чат
              </MenuItem>
              <MenuItem onClick={() => markAsPersonalChat && markAsPersonalChat()} className="flex items-center gap-2">
                <FaEyeSlash size={14} />
                Пометить как персональный чат
              </MenuItem>
              <MenuItem
                onClick={() => setIsCreateLeadModalOpen(true)}
                className="flex items-center gap-2"
              >
                {/* Создать заявку */}
                <FaFileAlt size={14} />
                Создать заявку
              </MenuItem>
              {chat?.activeAutomationID && (
                <MenuItem onClick={handleResetAutomation} className="flex items-center gap-2">
                  <FaSyncAlt size={14} />
                  Сбросить автоматизацию
                </MenuItem>
              )}
            </Menu>
          </div>
        </div>
      </div>
      <div className="messages-body">
        {isLoading ? (
          <div className="text-center"></div>
        ) : (
          Object.entries(groupMessagesByDate(messages)).map(([date, messages]: any) => (
            <div key={date} className="mb-8 mt-8">
              <div className="message-date text-center mb-2">
                <span className="p-2 border rounded inline-block">{toFullDateName(date)}</span>
              </div>
              {messages.map((message: any) => (
                <ChatMessageItem
                  key={message.id}
                  message={message}
                  chat={chat}
                  deleteMessage={deleteMessage}
                  sendMessage={sendMessage}
                />
              ))}
            </div>
          ))
        )}
      </div>
      <div className="messages-input">
        <form onSubmit={onSubmit} className="w-100">
          <TextField
            id="message-input"
            label="Сообщение"
            inputRef={messageInputRef}
            fullWidth
            multiline
            minRows={2}
            maxRows={10}
            required
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Button variant="contained" color="primary" type="submit">
                    Отправить
                  </Button>
                </InputAdornment>
              ),
            }}
          />
        </form>
      </div>
      {/* Create lead modal */}
      <Dialog
        fullWidth
        maxWidth="md"
        open={isCreateLeadModalOpen}
        onClose={() => setIsCreateLeadModalOpen(false)}
      >
        <DialogTitle>Создать заявку</DialogTitle>
        <DialogContent>
          <form onSubmit={handleSubmit(createLead)} className="flex flex-col gap-2">
            <TextField label="Имя" fullWidth {...register("name")} />
            <TextField label="Телефон" fullWidth {...register("phone")} />
            <div className="flex gap-2">
              <TextField
                type="date"
                label="Дата от"
                fullWidth
                {...register("data.dateFrom")}
                InputLabelProps={{
                  shrink: true,
                }}
              />
              <TextField
                type="date"
                label="Дата до"
                fullWidth
                {...register("data.dateTo")}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </div>
            <TextField type="number" label="Бюджет" fullWidth {...register("data.budget")} />
            <TextField label="Продукт" fullWidth {...register("data.product")} />
            <TextField
              type="number"
              label="Количество людей"
              fullWidth
              {...register("data.personQuantity")}
              InputLabelProps={{
                shrink: true,
              }}
            />
            <TextField label="Туристы" fullWidth {...register("data.customers")} />
            <TextField
              type="text"
              label="Город отправления"
              fullWidth
              {...register("data.departureCity")}
            />
            <Button variant="contained" color="primary" type="submit">
              Создать
            </Button>
            {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}
          </form>
        </DialogContent>
      </Dialog>
    </div>
  );
};

function groupMessagesByDate(messages: any[]) {
  return messages.reduce((acc, message) => {
    const date = toNativeDate(message.createdAt);
    if (!acc[date]) {
      acc[date] = [];
    }
    acc[date].push(message);
    return acc;
  }, {});
}
